import { render, staticRenderFns } from "./NewsInformation.vue?vue&type=template&id=4dc5c4ca&scoped=true"
import script from "./NewsInformation.vue?vue&type=script&lang=js"
export * from "./NewsInformation.vue?vue&type=script&lang=js"
import style0 from "./NewsInformation.vue?vue&type=style&index=0&id=4dc5c4ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc5c4ca",
  null
  
)

export default component.exports